import Vue from "vue";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import {
  LoadingBar,
  Message,
  DatePicker,
  Button,
  Form,
  Alert,
  Input,
  Table,
  FormItem
} from "iview";
import VueRouter, { RouterOptions } from "vue-router";
import Routers from "./router";
import Util from "./libs/util";
import App from "./app.vue";
import myTable from "./components/my-table.vue";
import myGotop from "./components/goTop.vue";
import api from "./api/index";
import "iview/dist/styles/iview.css";
import minx from "./minxs/index";
import * as axios from 'axios'
// import "./registerServiceWorker";
Vue.prototype.$api = api;
Vue.prototype.$http = axios
Vue.prototype.$LoadingBar = LoadingBar;
Vue.prototype.$Message = Message;
Vue.prototype.$Sentry = Sentry;
Vue.use(VueRouter);
Vue.mixin(minx);
Vue.component("FormItem", FormItem);
Vue.component("DatePicker", DatePicker);
Vue.component("Button", Button);
Vue.component("Form", Form);
Vue.component("my-table", myTable);
Vue.component("my-gotop", myGotop);
Vue.component("Alert", Alert);
Vue.component("Input", Input);
Vue.component("Table", Table);
// 路由配置
const RouterConfig: RouterOptions = {
  mode: "history",
  routes: Routers
};
const router = new VueRouter(RouterConfig);

router.beforeEach((to: any, from: any, next: () => void) => {
  Vue.prototype.$LoadingBar.start();
  Util.title(to.meta.title);
  next();
});

router.afterEach(() => {
  Vue.prototype.$LoadingBar.finish();
  window.scrollTo(0, 0);
});

new Vue({
  el: "#app",
  router: router,
  render: h => h(App)
});
// sentry init
const needStart = process.env.G_ENV === "prod" ? false : true;

Sentry.init({
  enabled: needStart,
  debug: needStart,
  dsn: "https://829ab498be3644d29b8c193c53ffa602@sentry.gelonghui.com/3",
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true
    })
  ]
});
